// extracted by mini-css-extract-plugin
export var label = "_g6-2";
export var slideContainer = "_g6-0";
export var slider = "_g6-1";